// extracted by mini-css-extract-plugin
export default {"header":"header_header__z8ezc","logo":"header_logo__wLirW","titleSection":"header_titleSection__jrryJ","selectSection":"header_selectSection__lrRmO"};